import { useState } from "react"
import { useTranslation } from "react-i18next"
import ReactModal from "react-modal"
import { ReactComponent as CloseIcon } from "feather-icons/dist/icons/x.svg"

import Button from "../Button"

import ModalProps from "./ModalProps"

import "./styles.scss"

ReactModal.setAppElement("body")

const Modal = ({
  isOpen,
  title,
  setIsOpen,
  onConfirm,
  onCancel,
  width = 400,
  cancelButtonText,
  confirmButtonText,
  showConfirm = true,
  showCancel = true,
  showClose = true,
  children,
  ...restProps
}: ModalProps) => {
  const { t } = useTranslation("sales")
  const [confirmLoading, setConfirmLoading] = useState(false)
  const [cancelLoading, setCancelLoading] = useState(false)
  const handleCancel = () => {
    new Promise((resolve) => {
      setCancelLoading(true)
      resolve(true)
    })
      .then(onCancel)
      .finally(() => {
        setCancelLoading(false)
        setIsOpen(false)
      })
  }

  const handleConfirm = () => {
    new Promise((resolve) => {
      setConfirmLoading(true)
      resolve(true)
    })
      .then(onConfirm)
      .finally(() => {
        setConfirmLoading(false)
        setIsOpen(false)
      })
  }

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={handleCancel}
      portalClassName="customer-attach-modal"
      overlayClassName="customer-attach-overlay"
      style={{
        content: {
          maxWidth: `${width}px`,
        },
      }}
      {...restProps}>
      <div className="modal-title">
        {title}
        {showClose && (
          <CloseIcon data-testid="customer-attach-modal-close-icon" className="close-icon" onClick={handleCancel} />
        )}
      </div>
      <div className="modal-body">{children}</div>
      <div className="modal-footer">
        {showCancel && (
          <Button outline onClick={handleCancel} loading={cancelLoading} disabled={cancelLoading}>
            {cancelButtonText || t("button.cancel")}
          </Button>
        )}
        {showConfirm && (
          <Button onClick={handleConfirm} loading={confirmLoading} disabled={confirmLoading}>
            {confirmButtonText || t("btn_ok")}
          </Button>
        )}
      </div>
    </ReactModal>
  )
}

export default Modal
